import type { CustomChatChannel } from '../types';

const parseDateCandidate = (value: unknown): Date | null => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const text = String(value).trim();
  if (!text) return null;

  const date = new Date(text);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getCustomChatChannelActivityTime = (
  channel: CustomChatChannel
): number => {
  const candidates = [
    channel.last_message_at,
    channel.last_message?.updated_at,
    channel.last_message?.created_at,
  ];

  for (const candidate of candidates) {
    const timestamp = parseDateCandidate(candidate)?.getTime();
    if (timestamp) return timestamp;
  }

  return 0;
};

export const compareCustomChatChannelsByStableKey = (
  firstChannel: CustomChatChannel,
  secondChannel: CustomChatChannel
) =>
  `${firstChannel.title ?? ''}:${firstChannel.id}`.localeCompare(
    `${secondChannel.title ?? ''}:${secondChannel.id}`,
    undefined,
    {
      numeric: true,
      sensitivity: 'base',
    }
  );

export const compareCustomChatChannelsByRecentActivity = (
  firstChannel: CustomChatChannel,
  secondChannel: CustomChatChannel
) => {
  const activityDiff =
    getCustomChatChannelActivityTime(secondChannel) -
    getCustomChatChannelActivityTime(firstChannel);

  if (activityDiff) return activityDiff;

  return compareCustomChatChannelsByStableKey(firstChannel, secondChannel);
};

export const sortCustomChatChannelsByRecentActivity = (
  channels: CustomChatChannel[]
): CustomChatChannel[] =>
  [...channels].sort(compareCustomChatChannelsByRecentActivity);
